import { isNil, isNumeric, prop, forIn, isPlain, has } from './base'

// 动作派发
function dispatchSync(pathName) {
  return ({ dispatch }, args) =>
    dispatch(pathName, args, {
      root: true
    })
}

function dispatchAsync(pathName) {
  return async (opts, args) => {
    const { dispatch } = opts
    const R = await dispatch(pathName, args, {
      root: true
    })
    return R
  }
}

// 快捷方式：提交
function shortCommit(pathName) {
  return ({ dispatch }, args) =>
    dispatch(pathName, args, {
      root: true
    })
}

// 快捷读取
function _pathValue(state, paths, defaultValue) {
  const maxIndex = paths.length - 1
  const attrName = paths[maxIndex]
  if (attrName) {
    for (let i = 0; i < maxIndex; i++) {
      state = state[paths[i]]
      if (isNil(state)) {
        return defaultValue
      }
    }
    const value = state[attrName]
    return isNil(value) ? defaultValue : value
  }
  return defaultValue
}

function shortRootState(pathKey, defaultValue) {
  const paths = pathKey.split('/')
  return (_state, _getters, rootState) => {
    const value = _pathValue(rootState, paths, defaultValue)
    return isNil(value) ? defaultValue : value
  }
}

function shortRootStateN(pathKey, defaultValue) {
  defaultValue = isNumeric(defaultValue) ? +defaultValue : 0
  const getFn = shortRootState(pathKey, defaultValue)
  return (state, getters, rootState) => {
    const value = getFn(state, getters, rootState)
    return isNumeric(value) ? +value : defaultValue
  }
}

function shortRootGetter(pathKey, defaultValue) {
  return (_state, _getters, _rootState, rootGetters) => {
    const value = rootGetters[pathKey]
    return isNil(value) ? defaultValue : value
  }
}

function shortObjValue(pathKey, defaultValue) {
  const paths = pathKey.split('/')
  return state => _pathValue(state, paths, defaultValue)
}

function makeMapValueF1(mapName, defaultValue) {
  return state => id => prop(state[mapName], id, defaultValue)
}

function makeMapValueF2(mapName, attrName, defaultValue) {
  // return state => id =>
  //     prop(prop(state[mapName], id), attrName, defaultValue);
  return state => id => _pathValue(state, [mapName, id, attrName], defaultValue)
}

export {
  // 快捷方式：动作派发
  dispatchSync,
  dispatchAsync,
  // 快捷方式：提交
  shortCommit,
  // 快捷方式：读取
  shortRootState,
  shortRootStateN,
  shortRootGetter,
  shortObjValue,
  // 读取 mapObj 值
  makeMapValueF1,
  makeMapValueF2
}

// 创建合并函数
function update(state, values) {
  forIn(values, (value, key) => {
    if (has(state, key)) {
      state[key] = value
      // } else {
      //     console.log([key, value])
    }
  })
  return state
}

function deepUpdate(state, values) {
  forIn(values, (value, key) => {
    if (has(state, key)) {
      const o = state[key]
      // 目前仅支持 object 深度替换
      if (isPlain(o) && isPlain(value)) {
        return deepUpdate(o, value)
      } else {
        // TODO 待完善
        state[key] = value
      }
    }
  })
  return state
}

export { update, deepUpdate }
